import React from 'react';
import { RailsPredictiveSearchResult } from '@sls-react/typings/services/rails/predictiveSearch';
import PredictiveResultLink from '@sls-react/components/Links/PredictiveResultLink';

interface Props {
  className?: any;
  css?: any;
  results: RailsPredictiveSearchResult[];
}

const PredictiveResultsList: React.FC<Props> = ({ results, ...props }) => (
  <ul {...props}>
    {results.map(result => (
      <li key={result.id}>
        <PredictiveResultLink
          className="block px-3 py-2 hover:text-black hover:bg-grey-200"
          result={result}
        >
          {result.name}{' '}
          {result.category_name && (
            <>
              in <b>{result.category_name}</b>
            </>
          )}
        </PredictiveResultLink>
      </li>
    ))}
  </ul>
);

export default PredictiveResultsList;
